module.exports = __webpack_public_path__ + "img/02.0487f706.png";